/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type { DeleteFileErrorTypeErrorResponse } from './api.schemas';

import { api } from '../util/http';

export const deleteEncountersFiles = (encounterId: number, fileId: number) => {
  return api<void>({ url: `/api/encounters/${encounterId}/files/${fileId}`, method: 'DELETE' });
};

export const getDeleteEncountersFilesMutationOptions = <
  TError = DeleteFileErrorTypeErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEncountersFiles>>,
    TError,
    { encounterId: number; fileId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEncountersFiles>>,
  TError,
  { encounterId: number; fileId: number },
  TContext
> => {
  const mutationKey = ['deleteEncountersFiles'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEncountersFiles>>,
    { encounterId: number; fileId: number }
  > = (props) => {
    const { encounterId, fileId } = props ?? {};

    return deleteEncountersFiles(encounterId, fileId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteEncountersFilesMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEncountersFiles>>
>;

export type DeleteEncountersFilesMutationError = DeleteFileErrorTypeErrorResponse;

export const useDeleteEncountersFiles = <
  TError = DeleteFileErrorTypeErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEncountersFiles>>,
      TError,
      { encounterId: number; fileId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteEncountersFiles>>,
  TError,
  { encounterId: number; fileId: number },
  TContext
> => {
  const mutationOptions = getDeleteEncountersFilesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
